export enum ConclusionPhaseEnum {
    PENDING = 'pending',
    COMPLIANCE_MANUAL_ANALYSIS = 'compliance_manual_analysis',
    CREDIT_MANUAL_ANALYSIS = 'credit_manual_analysis',
    APPROVED = 'approved',
    REJECTED = 'rejected'
}
